const Note = (props) => props.children ? <p style={{fontStyle: 'italic', marginBottom: 0}}>{props.children}</p> : null
export default Note